// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_14xzA","button":"GHWa5"};